module.exports = __webpack_public_path__ + "media/智能--社区监控.82963a8a.mp4";